import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t&::-webkit-slider-thumb {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t\t&::-moz-range-thumb {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t&::-webkit-slider-runnable-track {\n\t\tbackground: linear-gradient(\n\t\t\tto right,\n\t\t\t", " calc(var(--progress)),\n\t\t\t", " calc(var(--progress))\n\t\t);\n\t}\n\t&::-moz-range-track {\n\t\tbackground: linear-gradient(\n\t\t\tto right,\n\t\t\t", " calc(var(--progress)),\n\t\t\t", " calc(var(--progress))\n\t\t);\n\t}\n\n\t&::-webkit-slider-thumb {\n\t\tbackground-color: ", ";\n\t\tborder: 1px solid ", ";\n\t}\n\t&::-moz-range-thumb {\n\t\tbackground-color: ", ";\n\t\tborder: 1px solid ", ";\n\t}\n\n\t&:focus {\n\t\t", ";\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tappearance: none;\n\tbackground-color: transparent;\n\tborder: 1px solid transparent;\n\tborder-radius: ", ";\n\tcursor: pointer;\n\tdisplay: block;\n\theight: ", ";\n\tmax-width: 100%;\n\tmin-width: 0;\n\tpadding: ", ";\n\twidth: 100%;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&::-moz-focus-outer {\n\t\tborder: 0;\n\t}\n\n\t&::-webkit-slider-runnable-track {\n\t\tbackground: linear-gradient(\n\t\t\tto right,\n\t\t\t", " calc(var(--progress)),\n\t\t\t", " calc(var(--progress))\n\t\t);\n\t\tborder-radius: 2px;\n\t\theight: 2px;\n\n\t\t*:disabled& {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n\t&::-moz-range-track {\n\t\tbackground: linear-gradient(\n\t\t\tto right,\n\t\t\t", " calc(var(--progress)),\n\t\t\t", " calc(var(--progress))\n\t\t);\n\t\tborder-radius: 2px;\n\t\theight: 2px;\n\t\twill-change: transform;\n\n\t\t*:disabled& {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n\n\t&::-webkit-slider-thumb {\n\t\tappearance: none;\n\t\tbackground-color: ", ";\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 50%;\n\t\tbox-shadow: ", ";\n\t\tcursor: pointer;\n\t\theight: 12px;\n\t\tmargin-top: -5px;\n\t\topacity: 1;\n\t\twidth: 12px;\n\t\ttransition: box-shadow ease ", ";\n\n\t\t*:disabled& {\n\t\t\tbackground: ", ";\n\t\t\tborder-color: ", ";\n\t\t}\n\t}\n\t&::-moz-range-thumb {\n\t\tappearance: none;\n\t\tbackground-color: ", ";\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 50%;\n\t\tbox-shadow: ", ";\n\t\tcursor: pointer;\n\t\theight: 12px;\n\t\tmargin-top: -5px;\n\t\topacity: 1;\n\t\twidth: 12px;\n\t\ttransition: box-shadow ease ", ";\n\t\twill-change: transform;\n\n\t\t*:disabled& {\n\t\t\tbackground: ", ";\n\t\t\tborder-color: ", ";\n\t\t}\n\t}\n\n\t&:focus {\n\t\t", "\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Slider = css(_templateObject(), ui.get('controlBorderRadius'), ui.get('controlHeight'), ui.space(1), ui.color.admin, ui.get('controlBackgroundDimColor'), ui.get('controlBackgroundDimColor'), ui.color.admin, ui.get('controlBackgroundDimColor'), ui.get('controlBackgroundDimColor'), ui.get('sliderThumbBackgroundColor'), ui.get('sliderThumbBorderColor'), ui.get('sliderThumbBoxShadow'), ui.get('transitionDurationFast'), ui.get('colorTextMuted'), ui.get('colorTextMuted'), ui.get('sliderThumbBackgroundColor'), ui.get('sliderThumbBorderColor'), ui.get('sliderThumbBoxShadow'), ui.get('transitionDurationFast'), ui.get('colorTextMuted'), ui.get('colorTextMuted'), getFocusBoxShadow());
export var focused = css(_templateObject2(), getFocusBoxShadow());
export var large = css(_templateObject3(), ui.get('controlHeightLarge'));
export var small = css(_templateObject4(), ui.get('controlHeightSmall'));
export var error = css(_templateObject5(), ui.get('controlDestructiveBorderColor'), ui.get('controlBackgroundDimColor'), ui.get('controlDestructiveBorderColor'), ui.get('controlBackgroundDimColor'), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColor'), getFocusBoxShadow(ui.get('controlDestructivePseudoBoxShadowFocusSmall')));
export var focusedError = css(_templateObject6(), getFocusBoxShadow(ui.get('controlDestructivePseudoBoxShadowFocusSmall')));

function getFocusBoxShadow(color) {
  if (color === void 0) {
    color = ui.get('controlPseudoBoxShadowFocusSmall');
  }

  return css(_templateObject7(), color, color);
}